import { propMap } from "./readcubeMap"
import meta from "@readcube/rcp-meta/type_schema.json"
import { defaultTypeNameFromMapping } from "@readcube/rcp-meta"
import { CommonOptions, getNewLine, getYearMonth, removeEmpty, onFile } from "../common"
import { format, bibAuthorFormat } from "./format"
import _get from "lodash/get"

export const asBib = ({ item, newLine, mapping }: CommonOptions) => {

  const nl = getNewLine(newLine)
  let out = {}

  addReadcubeItemData(out, item)
  out = getMetadata(out, item, mapping || meta)
  out = removeEmpty(out)
  return format(out, item, mapping || meta, nl)
}

const addReadcubeItemData = (out: any, item: any) => {
  for (const [name, generator] of Object.entries(propMap)) {
    if (!out[name])
      out[name] = generator(item)
  }
}

const getMetadata = (out: any, item: any, mapping: any) => {

  const defaultTypeName = defaultTypeNameFromMapping(mapping)

  const type =
    item.custom_type
      || item.item_type
      || defaultTypeName

  let typeFields = mapping.types[type]?.fields
  if (!typeFields)
    typeFields = mapping.types[defaultTypeName]?.fields

  const custom = typeFields
    .map((field: any) => {
      const fieldName = field.name || field
      const fieldDef = mapping.field_defs[fieldName]
      return [fieldName, fieldDef]
    })
    .filter((fieldWithDef: any) => fieldWithDef[1] && fieldWithDef[1].bib)
    .reduce((acc: any, fieldWithDef: any) => {
      const [field, fieldDef] = fieldWithDef
      const value = fieldDef.readcube
        ? _get(item, fieldDef.readcube)
        : item.custom_metadata && item.custom_metadata[fieldDef.custom_metadata]

      const bib =
        fieldDef.bib?.includes(',')
          ? fieldDef.bib.split(',')[0]
          : fieldDef.bib

      acc[bib] = transform(bib, value)

      return acc
    }, {})

  if (item.custom_metadata && (item.custom_metadata.published || item.custom_metadata.date)) {
    const { year, month } = getYearMonth(item.custom_metadata.published || item.custom_metadata.date)
    if (year) custom.year = year
    if (month) custom.month = month
  }

  if (out.year != null)
    delete custom.year

  onFile(item, path => custom["local-url"] = path)

  return { ...removeEmpty(out), ...removeEmpty(custom) }

  function transform(field: any, value: any) {
    const transforms = {
      author  : bibAuthorFormat,
      editor  : (v: any) => v && bibAuthorFormat((v + "").split(",")),
      pages   : (v: any) => ((v || "") + "").replace("-", "--"),
    } as any

    return transforms[field]
      ? transforms[field](value)
      : value
  }
}
